(function () {
    'use strict';

    angular
        .module('searchControllers', ['services.authenticatedUser']);
})();
